/* eslint-disable no-unused-vars */
import { omit } from 'lodash';

import { N_THUMBNAILS_PER_SLIDE } from 'constants/pdp';
import actions from 'state/constants';
import initialState from 'state/initialState';

const fetchedPdpMasterProductReducer = (state, action) => ({
  ...state,
  masterProduct: {
    ...action.payload.data,
    products: Object.keys(action.payload.data.products),
  },
  products: {
    ...state.products,
    ...action.payload.data.products,
  },
});

const setProductDataReducer = (state, action) => ({
  ...state,
  products: {
    ...state.products,
    [action.payload.handle]: action.payload,
  },
});

const setCurrentProductReducer = (state, action) => ({
  ...state,
  currentProduct: action.payload,
  currentMainCarouselSlide: 0,
  currentThumbnailCarouselSlide: 0,
});

const setInitialProductReducer = (state, action) => ({
  ...state,
  initialProduct: action.payload,
});

const setCurrentAttributeReducer = (state, action) => ({
  ...state,
  currentOpenAttributeIndex: action.payload,
});

const setCurrentSizeReducer = (state, action) => ({
  ...state,
  currentSize: action.payload,
});

const setVideoModalUrlReducer = (state, action) => ({
  ...state,
  videoModalUrl: action.payload,
});

const setCurrentMainCarouselSlideReducer = (state, action) => {
  const currentMainCarouselSlide = action.payload;

  const currentThumbnailCarouselSlide = Math.floor(
    currentMainCarouselSlide / N_THUMBNAILS_PER_SLIDE
  );

  return {
    ...state,
    currentMainCarouselSlide,
    currentThumbnailCarouselSlide,
  };
};

const setCurrentThumbnailCarouselSlideReducer = (state, action) => ({
  ...state,
  currentThumbnailCarouselSlide: action.payload,
});

const setAdditonalPdpModuleDataReducer = (state, action) => ({
  ...state,
  modules: {
    ...state.modules,
    ...action.payload.modules,
  },
});

const setSelectedQuantity = (state, action) => ({
  ...state,
  selectedQuantity: action.payload.quantity,
});

// Figure out how to update state based on incoming action type
export const reducer = (state = initialState.pdp, action) => {
  switch (action.type) {
    case actions.SET_CURRENT_PRODUCT:
      return setCurrentProductReducer(state, action);

    case actions.SET_INITIAL_PRODUCT:
      return setInitialProductReducer(state, action);

    case actions.SET_PRODUCT_DATA:
      return setProductDataReducer(state, action);

    case actions.FETCH_MASTER_PRODUCT_SUCCESS:
      return fetchedPdpMasterProductReducer(state, action);

    case actions.SET_CURRENT_ATTRIBUTE_INDEX:
      return setCurrentAttributeReducer(state, action);

    case actions.SET_CURRENT_SIZE:
      return setCurrentSizeReducer(state, action);

    case actions.SET_CURRENT_MAIN_CAROUSEL_SLIDE:
      return setCurrentMainCarouselSlideReducer(state, action);

    case actions.SET_PDP_MODULE_DATA:
      return setAdditonalPdpModuleDataReducer(state, action);

    case actions.SET_CURRENT_THUMBNAIL_CAROUSEL_SLIDE:
      return setCurrentThumbnailCarouselSlideReducer(state, action);

    case actions.SET_PDP_VIDEO_MODAL_URL:
      return setVideoModalUrlReducer(state, action);

    case actions.SELECT_QUANTITY:
      return setSelectedQuantity(state, action);

    case actions.FETCH_MASTER_PRODUCT_REQUEST:
    case actions.FETCH_MASTER_PRODUCT_FAILURE:
    default:
      return state;
  }
};

export default reducer;
